import { createFileRoute } from "@tanstack/react-router";

import { parseRatingsSearch } from "@/features/specialists";
import { RatingsPage } from "@/features/specialists/pages";
import { strictSearch } from "@/shared/lib/search";

/** The ratings of every specialist: the low ones, the hidden ones. */
export const Route = createFileRoute("/_app/specialists/ratings")({
  validateSearch: strictSearch(parseRatingsSearch),
  component: Ratings,
});

function Ratings() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <RatingsPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
    />
  );
}
